
import { defineComponent, toRefs } from "vue";
import Panel from "./Panel.vue";
import RadioInput from "./RadioInput.vue";
import SelectInput from "./SelectInput.vue";
import NumberInput from "./NumberInput.vue";
import useToolbar from "@/composables/useToolbar";

import pagePresets from "@/assets/data/page-presets.json";

export default defineComponent({
  name: "ToolbarCalculator",
  components: {
    Panel,
    NumberInput,
    SelectInput,
    RadioInput
  },
  setup() {
    const { global, current, dimensions, margins, grid } = useToolbar();

    const { leading, preset, checkGrid } = toRefs(global);
    const { unit, step, closedPanels } = toRefs(current);
    const { width, height, orientation } = toRefs(dimensions);
    const { top, bottom } = toRefs(margins);
    const { gutter, rows } = toRefs(grid);

    const setOrientation = (event: { target: HTMLInputElement }) => {
      const target = event.target.value;
      if (
        (target === "landscape" && dimensions.width < dimensions.height) ||
        (target === "portrait" && dimensions.width > dimensions.height)
      ) {
        [dimensions.width, dimensions.height] = [
          dimensions.height,
          dimensions.width
        ];
        dimensions.orientation = target;
      }
    };

    return {
      leading,
      checkGrid,
      preset,
      step,
      unit,
      width,
      height,
      orientation,
      top,
      bottom,
      gutter,
      rows,
      setOrientation,
      pagePresets,
      closedPanels
    };
  }
});
